/**
 * NuovaPrenotazione Page - Page Shell
 * Form creazione prenotazione
 */

import { useState } from "react";
import { PrenotazioneForm } from "@/features/prenotazioni";

export default function NuovaPrenotazione() {
  const [open, setOpen] = useState(true);
  
  return (
    <PrenotazioneForm 
      open={open}
      onOpenChange={setOpen}
      onSaved={() => {
        window.location.href = "/prenotazioni";
      }}
    />
  );
}
